import { jsx as l } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import * as d from "@radix-ui/react-toggle-group";
import { twMerge as u } from "tailwind-merge";
const s = m(
  ({ className: t, children: a, ...e }, o) => {
    const f = (r) => {
      var n, i;
      if (e.type === "single") {
        if (!r)
          return;
        (n = e.onValueChange) == null || n.call(e, r);
      } else e.type === "multiple" && ((i = e.onValueChange) == null || i.call(e, r));
    };
    return /* @__PURE__ */ l(
      d.Root,
      {
        ref: o,
        className: u("flex flex-wrap items-stretch rounded-xl bg-gray-100 p-1", t),
        ...e,
        onValueChange: f,
        children: a
      }
    );
  }
);
s.displayName = "ButtonGroup";
const x = m(
  ({ className: t, children: a, ...e }, o) => /* @__PURE__ */ l(
    d.Item,
    {
      ref: o,
      className: u(
        "group flex items-center justify-center whitespace-normal text-center",
        "h-auto min-h-10 flex-1 rounded-lg bg-transparent px-4 py-2",
        "text-base font-medium text-gray-600",
        "radix-state-on:bg-white radix-state-on:text-black radix-state-on:drop-shadow-sm",
        "radix-disabled:cursor-not-allowed radix-disabled:text-gray-400 radix-disabled:opacity-50",
        t
      ),
      ...e,
      children: a
    }
  )
);
x.displayName = "ButtonGroupItem";
const y = s, b = x;
export {
  s as ButtonGroup,
  x as ButtonGroupItem,
  b as Item,
  y as Root
};
